(function(){
  if(window.SNConversion)return;
  const sent=new Set();
  const names=new Set(['sn_package_selected','sn_service_slot_selected','sn_diagnostic_slot_selected','sn_parts_enquiry_opened','sn_bike_enquiry_opened','sn_addon_selected','sn_service_checkout_started','sn_parts_product_viewed','sn_parts_cart_added','sn_parts_cart_viewed','sn_parts_checkout_clicked','sn_parts_browse_clicked','sn_whatsapp_opened']);
  const allowed=new Set(['booking_type','product','package','value','catalog_id','variant_id','quantity','item_count','page_type']);
  if(!window.Shopify?.customerPrivacy&&typeof window.Shopify?.loadFeatures==='function'){
    window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function(){});
  }
  function emit(event,details={}){
    if(!names.has(event))return false;
    let consent=false;
    try{consent=window.Shopify?.customerPrivacy?.analyticsProcessingAllowed()===true;}catch{}
    if(!consent)return false;
    const payload={};
    for(const [key,value] of Object.entries(details)){
      if(!allowed.has(key))continue;
      if(typeof value==='number'&&Number.isFinite(value))payload[key]=value;
      else if(typeof value==='string'&&/^[a-zA-Z0-9_\- ./]{1,100}$/.test(value))payload[key]=value;
    }
    payload.page_type=document.documentElement.dataset.template||'page';
    try{
      const result=window.Shopify?.analytics?.publish?.(event,payload);
      if(result?.catch)result.catch(function(){});
    }catch{}
    if(typeof window.gtag==='function')window.gtag('event',event,payload);
    else (window.dataLayer=window.dataLayer||[]).push({event,...payload});
    return true;
  }
  window.SNConversion={emit};
  function once(event,details){
    const key=event+JSON.stringify(details);
    if(sent.has(key))return;
    if(emit(event,details))sent.add(key);
  }
  document.addEventListener('click',event=>{
    const target=event.target.closest?.('button,a');if(!target)return;
    if(target.id==='service-btn'||target.id==='bundle-btn')emit('sn_package_selected',{booking_type:'paid_service',package:target.id==='service-btn'?'service':'bundle'});
    if(target.classList.contains('time-slot'))once('sn_service_slot_selected',{booking_type:'paid_service'});
    if(target.classList.contains('diag-slot'))once('sn_diagnostic_slot_selected',{booking_type:'diagnostic'});
    if(target.matches('#whatsapp'))emit('sn_parts_enquiry_opened',{booking_type:'parts_enquiry'});
    else if(target.matches('.snbd .acts .wa,.snbk .wa'))emit('sn_bike_enquiry_opened',{booking_type:'bike_enquiry'});
    else if(target.matches('a[href^="https://wa.me/"],a[href^="https://api.whatsapp.com/"]'))emit('sn_whatsapp_opened');
  });
  document.addEventListener('change',event=>{
    if(event.target.matches('.addon-item input'))emit('sn_addon_selected',{booking_type:'paid_service',package:window.SN_SERVICE_CONFIG?.mode||'service'});
  });
})();
